// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e69a6b4f","513":"f073355d","787":"d848218f"}[chunkId] + ".chunk.js";
};